import { Injectable } from '@angular/core';

import { BaseHttpService } from 'shared/base/_base-http.service';
import { Config } from 'shared/config/env.config';
import { Detail } from '../models/detail.model';
import { segmentsData } from '../../product-details/segments-data-stub';

import { BehaviorSubject ,  Observable } from 'rxjs';
import * as _ from 'lodash';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class DetailService extends BaseHttpService {

  fetch(brandId: string, id: number): Observable<any> {
    return this.http.get(Config.API + '/items/' + brandId + '/' + id.toString())

        .pipe(
            map( itemDetail => this.mapDetail(itemDetail)),
            catchError(this.handleError.bind(this))
        );
  }

  mapDetail(itemDetail: any) {
    const detail = new Detail();
    _.each(segmentsData.items_details, (o: any) => {
      if (o.field_map) {  _.set(detail, o.field_map, _.get(itemDetail, o.item_name, null) ); }
    });
    return detail;
  }
}
